import { createButton } from 'react-simple-wysiwyg';

import { ReverseRightIcon } from '@/assets/icons/ReverseRightIcon';

export default createButton('Redo', <ReverseRightIcon />, 'redo');
